var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Entity, formatNumber } from '@debbie/common/dist';
import { CaseVoucherSource, } from '@debbie/common/dist/economy/case-vouchers';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup';
import { Button, DateInput, SearchInput, Input } from '../..';
import { toDecimal, toPercent } from '../../../utils';
import Checkbox from '../../Checkbox';
import MoneyInput from '../../MoneyInput';
import NewEntityProperties from '../../Properties/NewEntityProperties';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
const VoucherTypeSettingsWithInterestRate = [
    VoucherTypeIds.YEARLYINTEREST,
    VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP,
    VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP,
    VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP,
];
const InterestVoucherCreator = (props) => {
    var _a, _b;
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const [manualDate, setManualDate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [referenceVoucher, setReferenceVoucher] = useState(null);
    const [interest, setInterest] = useState(NaN);
    const [interestAmount, setInterestAmount] = useState(NaN);
    const [date, setDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [imposedByCreditor, setImposedByCreditor] = useState(false);
    const [properties, setProperties] = useState(null);
    const vouchers = props.caseVouchers;
    const canSubmit = (VoucherTypeSettingsWithInterestRate.includes(props.voucherTypeId)
        ? !Number.isNaN(interest)
        : true) &&
        date != null &&
        referenceVoucher != null &&
        (props.voucherTypeId === VoucherTypeIds.FIXEDINTEREST
            ? !Number.isNaN(interestAmount)
            : true);
    const createVoucher = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!canSubmit) {
            return;
        }
        setLoading(true);
        yield props.onCreate({
            voucherTypeId: props.voucherTypeId,
            amount: props.voucherTypeId === VoucherTypeIds.FIXEDINTEREST
                ? -interestAmount
                : 0,
            date: date.toISOString(),
            interestStartDate: date.toISOString(),
            interestEndDate: endDate != null ? endDate.toISOString() : null,
            interest: VoucherTypeSettingsWithInterestRate.includes(props.voucherTypeId)
                ? interest
                : undefined,
            referenceCaseVoucherId: referenceVoucher === null || referenceVoucher === void 0 ? void 0 : referenceVoucher.caseVoucherId,
            source: imposedByCreditor
                ? CaseVoucherSource.Creditor
                : CaseVoucherSource.Collector,
            properties: properties || undefined,
        });
        setLoading(false);
    });
    const searchVouchers = useMemo(() => {
        const sv = vouchers.concat([]);
        sv.sort((a, b) => {
            if (a.category === b.category) {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            }
            return (CaseVoucherCategories.indexOf(a.category) -
                CaseVoucherCategories.indexOf(b.category));
        });
        return sv;
    }, [vouchers]);
    return (React.createElement(Wrapper, null,
        React.createElement(SearchInput, { resultsStyle: { maxHeight: '160px' }, placeholder: lang.economy.referenceVoucher, forceOpen: true, searchAll: (q) => {
                return searchVouchers
                    .filter((v) => [
                    VoucherCategory.PRINCIPAL,
                    VoucherCategory.COURTCOST,
                    VoucherCategory.COST,
                ].includes(v.category) &&
                    (`${v.label} (${formatNumber(v.amount)})`
                        .toLocaleLowerCase()
                        .indexOf(q.toLocaleLowerCase()) !== -1 ||
                        !q) &&
                    !v.referenceCaseVoucherId)
                    .map((v) => ({
                    key: v.caseVoucherId,
                    heading: (React.createElement(SearchWrapper, null,
                        React.createElement("span", null,
                            lang.economyVoucherTypeLabels[v.voucherTypeId] || v.label,
                            ' ',
                            v.referenceId),
                        React.createElement("span", null, formatNumber(Math.abs(v.amount))))),
                    subheading: lang.economyCategories[v.category],
                    returnData: v,
                }));
            }, onSelect: (v) => {
                setReferenceVoucher(v);
                if (!manualDate) {
                    setDate(moment(v.date).add(31, 'days').toDate());
                }
            }, onRemoveStatic: () => setReferenceVoucher(null), static: (referenceVoucher &&
                `${lang.economyVoucherTypeLabels[referenceVoucher.voucherTypeId] || referenceVoucher.label} ${(_a = referenceVoucher.referenceId) !== null && _a !== void 0 ? _a : ''} (${formatNumber(Math.abs(referenceVoucher.amount))})`) ||
                null }),
        VoucherTypeSettingsWithInterestRate.includes(props.voucherTypeId) && (React.createElement(Input, { containerStyle: { width: '100%' }, placeholder: lang.economy.interestRate, type: "number", value: !Number.isNaN(interest) ? toPercent(interest) : '', onChange: (e) => {
                setInterest(toDecimal(parseFloat(e.target.value)));
            } })),
        props.voucherTypeId === VoucherTypeIds.FIXEDINTEREST && (React.createElement(MoneyInput, { placeholder: lang.economy.interestAmount, value: !Number.isNaN(interestAmount) ? interestAmount : NaN, onChange: (c) => {
                setInterestAmount(Math.abs(c));
            } })),
        React.createElement(OneLine, null,
            React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: lang.economy.interestStartDate, value: moment(date), allowNull: false, onChange: (d) => {
                        setManualDate(true);
                        setDate(d.toDate());
                    } })),
            React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: lang.economy.interestEndDate, value: endDate != null ? moment(endDate) : undefined, allowNull: false, onChange: (d) => {
                        setEndDate(d.toDate());
                    } }))),
        React.createElement(Checkbox, { placeholder: lang.economy.imposedByCreditor, onChange: (e) => setImposedByCreditor(e.target.checked), checked: imposedByCreditor }),
        ((_b = singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseGroup) === null || _b === void 0 ? void 0 : _b.id) && (React.createElement(NewEntityProperties, { propRef: Entity.CaseVoucher, scope: "case_groups", scopeId: singleCase.caseGroup.id, onChange: (p) => {
                let exists = false;
                setProperties(properties && properties.length > 0
                    ? properties
                        .map((prop) => {
                        if (prop.handle === p.handle) {
                            exists = true;
                            return p;
                        }
                        else {
                            return prop;
                        }
                    })
                        .concat(exists ? [] : [p])
                    : [p]);
            } })),
        React.createElement(Button, { disabled: !canSubmit, style: { width: '100%' }, loading: loading, onClick: createVoucher },
            lang.economy.voucherCreationCreate,
            ' ',
            lang.economyVoucherTypeLabels[props.voucherTypeId])));
};
export default InterestVoucherCreator;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const OneLine = styled.div `
  display: flex;
  justify-content: space-between;
`;
const DateWrapper = styled.div `
  width: calc(50% - 10px);
`;
const SearchWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=InterestVoucherCreator.js.map